/* ==========================================================================
   NIGHT DUNE — theme behaviour
   Vanilla JS, no dependencies.
   ========================================================================== */

(function () {
  'use strict';

  var routes = window.routes || {};
  var strings = window.themeStrings || {};

  /* ------------------------------------------------------------------
     Helpers
     ------------------------------------------------------------------ */

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  var toastTimer;
  function toast(message) {
    var el = document.getElementById('Toast');
    if (!el) return;
    var text = el.querySelector('.toast__text');
    if (text) text.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 3200);
  }

  /* ------------------------------------------------------------------
     Drawers
     ------------------------------------------------------------------ */

  var lastFocused = null;

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var focusable = drawer.querySelector(
      'input:not([type="hidden"]), button, a[href], select, textarea'
    );
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('drawer-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function closeAllDrawers() {
    $$('.drawer.is-open').forEach(closeDrawer);
    $$('.modal.is-open').forEach(function (m) {
      m.classList.remove('is-open');
    });
    document.body.classList.remove('drawer-open');
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }

    var closer = event.target.closest('[data-drawer-close], .drawer__overlay');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.drawer'));
      return;
    }

    var modalOpener = event.target.closest('[data-modal-open]');
    if (modalOpener) {
      event.preventDefault();
      var modal = document.getElementById(modalOpener.getAttribute('data-modal-open'));
      if (modal) {
        modal.classList.add('is-open');
        document.body.classList.add('drawer-open');
      }
      return;
    }

    var modalCloser = event.target.closest('[data-modal-close], .modal__overlay');
    if (modalCloser) {
      event.preventDefault();
      var openModal = modalCloser.closest('.modal');
      if (openModal) openModal.classList.remove('is-open');
      if (!$('.drawer.is-open')) document.body.classList.remove('drawer-open');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllDrawers();
  });

  /* ------------------------------------------------------------------
     Cart
     ------------------------------------------------------------------ */

  function refreshCartUI() {
    return fetch(routes.cart_url + '?section_id=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('#CartDrawer');
        var current = document.getElementById('CartDrawer');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
        var count = parsed.querySelector('[data-cart-count-source]');
        if (count) {
          $$('[data-cart-count]').forEach(function (badge) {
            var value = count.getAttribute('data-cart-count-source');
            badge.textContent = value;
            badge.hidden = value === '0';
          });
        }
      })
      .catch(function () { /* network hiccup: leave the UI as-is */ });
  }

  function addToCart(form, button) {
    var data = new FormData(form);
    var original = button ? button.innerHTML : '';

    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.innerHTML = '&middot;&middot;&middot;';
    }

    return fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (response) { return response.json(); })
      .then(function (json) {
        if (json.status) {
          toast(json.description || json.message || 'Could not add to cart');
          return;
        }
        return refreshCartUI().then(function () {
          toast(strings.addedToCart || 'Added to cart');
          openDrawer('CartDrawer');
        });
      })
      .catch(function () {
        toast('Something went wrong. Please try again.');
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.innerHTML = original;
        }
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    event.preventDefault();
    var button = form.querySelector('[data-add-to-cart]') || form.querySelector('[type="submit"]');
    addToCart(form, button);
  });

  function changeCartLine(key, quantity) {
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { return refreshCartUI(); })
      .catch(function () { /* ignore */ });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeCartLine(remove.getAttribute('data-cart-remove'), 0);
      return;
    }

    var step = event.target.closest('[data-qty-step]');
    if (step) {
      event.preventDefault();
      var wrap = step.closest('.qty');
      var input = wrap ? wrap.querySelector('.qty__input') : null;
      if (!input) return;
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = parseInt(input.value || '1', 10) + parseInt(step.getAttribute('data-qty-step'), 10);
      if (next < min) next = min;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty]');
    if (!input) return;
    changeCartLine(input.getAttribute('data-cart-qty'), parseInt(input.value, 10));
  });

  /* ------------------------------------------------------------------
     Product: variant picker
     ------------------------------------------------------------------ */

  function initVariants(root) {
    // The variant JSON sits outside [data-product-root] in the markup, so a
    // root-scoped lookup finds nothing and the whole picker silently dies —
    // every add-to-cart then sends the first variant regardless of the size
    // the customer picked. Look in the root first, then fall back to the page.
    var dataEl = $('[data-variant-json]', root) || $('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var inputs = $$('.variant__option input', root);
    if (!inputs.length) return;

    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-product-price]', root);
    var buyButton = $('[data-add-to-cart]', root);
    var stickyPrice = $('[data-sticky-price]');
    var skuEl = $('[data-product-sku]', root);

    function selectedOptions() {
      var values = [];
      $$('.variant', root).forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) values.push(checked.value);
        var label = group.querySelector('.variant__value');
        if (label && checked) label.textContent = checked.value;
      });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (v.options[j] !== values[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function update() {
      var values = selectedOptions();
      var variant = findVariant(values);

      if (!variant) {
        if (buyButton) {
          buyButton.setAttribute('aria-disabled', 'true');
          buyButton.textContent = strings.unavailable || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        var html = '<span class="price__current">' + variant.price_formatted + '</span>';
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (onSale) {
          html += '<s class="price__compare">' + variant.compare_formatted + '</s>';
        }
        priceEl.innerHTML = html;
        priceEl.classList.toggle('price--on-sale', !!onSale);
      }

      if (stickyPrice) stickyPrice.textContent = variant.price_formatted;
      if (skuEl) skuEl.textContent = variant.sku || '';

      if (buyButton) {
        if (variant.available) {
          buyButton.removeAttribute('aria-disabled');
          buyButton.textContent = strings.addToCart || 'Add to cart';
        } else {
          buyButton.setAttribute('aria-disabled', 'true');
          buyButton.textContent = strings.soldOut || 'Sold out';
        }
      }

      if (variant.featured_media_id) {
        showSlide(root, String(variant.featured_media_id));
      }

      if (history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', update);
    });

    update();
  }

  /* ------------------------------------------------------------------
     Product: gallery
     ------------------------------------------------------------------ */

  function showSlide(root, mediaId) {
    var slide = $('[data-media-id="' + mediaId + '"]', root);
    if (!slide) return;
    $$('.product__slide', root).forEach(function (s) { s.classList.remove('is-active'); });
    slide.classList.add('is-active');
    $$('.product__thumb', root).forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb-id') === mediaId);
    });
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.product__thumb');
    if (!thumb) return;
    event.preventDefault();
    var root = thumb.closest('[data-product-root]') || document;
    showSlide(root, thumb.getAttribute('data-thumb-id'));
  });

  /* ------------------------------------------------------------------
     Sticky buy bar
     ------------------------------------------------------------------ */

  function initStickyBuy() {
    var bar = $('.sticky-buy');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -120px 0px' }
    );
    observer.observe(anchor);
  }

  /* ------------------------------------------------------------------
     Reveal on scroll
     ------------------------------------------------------------------ */

  function initReveal() {
    var items = $$('.reveal:not(.is-in)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------------------
     Predictive search
     ------------------------------------------------------------------ */

  function initSearch() {
    var input = $('[data-predictive-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results || !routes.predictive_search_url) return;

    var timer;

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);

      if (term.length < 2) {
        results.innerHTML = '';
        return;
      }

      timer = setTimeout(function () {
        var url =
          routes.predictive_search_url +
          '?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search';

        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var inner = parsed.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 250);
    });
  }

  /* ------------------------------------------------------------------
     Collection facets — auto submit
     ------------------------------------------------------------------ */

  function initFacets() {
    var form = $('[data-facet-form]');
    if (!form) return;

    form.addEventListener('change', function () {
      form.submit();
    });

    var sort = $('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    var toggle = $('[data-facet-toggle]');
    var panel = $('.facets');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        panel.classList.toggle('is-open');
      });
    }
  }

  /* ------------------------------------------------------------------
     Header behaviour
     ------------------------------------------------------------------ */

  function initHeader() {
    // Close any open desktop dropdown when clicking elsewhere.
    document.addEventListener('click', function (event) {
      $$('.nav__item[open]').forEach(function (item) {
        if (!item.contains(event.target)) item.removeAttribute('open');
      });
    });

    // Only one dropdown open at a time.
    $$('.nav__item').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        $$('.nav__item[open]').forEach(function (other) {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Announcement marquee — duplicate content so the loop is seamless
     ------------------------------------------------------------------ */

  function initMarquee() {
    $$('[data-marquee]').forEach(function (track) {
      if (track.dataset.cloned === 'true') return;
      var content = track.innerHTML;
      track.innerHTML = content + content;
      track.dataset.cloned = 'true';
    });
  }

  /* ------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------ */

  function init() {
    initReveal();
    initSearch();
    initFacets();
    initHeader();
    initMarquee();
    initStickyBuy();

    var productRoot = $('[data-product-root]');
    if (productRoot) initVariants(productRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on Shopify theme editor events so previews stay live.
  document.addEventListener('shopify:section:load', function (event) {
    initReveal();
    initMarquee();
    initHeader();
    var root = event.target.querySelector('[data-product-root]');
    if (root) initVariants(root);
  });

  document.addEventListener('shopify:section:select', function () {
    initReveal();
  });
})();

/* ==========================================================================
   NIGHT DUNE — motion layer
   Parallax, drifting sand, counters, the pinned story and the mobile bar.
   Every module bails out under prefers-reduced-motion.
   ========================================================================== */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* ------------------------------------------------------------------
     A single scroll loop. Modules register a callback rather than each
     attaching their own listener, so a phone only does this work once
     per frame.
     ------------------------------------------------------------------ */

  var scrollJobs = [];
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      for (var i = 0; i < scrollJobs.length; i++) scrollJobs[i](y);
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ------------------------------------------------------------------
     Scroll progress rail
     ------------------------------------------------------------------ */

  function initProgress() {
    var bar = document.getElementById('ScrollProgress');
    if (!bar || reduced.matches) return;

    scrollJobs.push(function (y) {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? Math.min(y / max, 1) : 0;
      bar.style.transform = 'scaleX(' + pct + ')';
    });
  }

  /* ------------------------------------------------------------------
     Parallax — hero media and the dune ridges
     ------------------------------------------------------------------ */

  function initParallax() {
    var items = $$('[data-parallax]');
    if (!items.length || reduced.matches) return;

    var hero = $('[data-hero]');

    scrollJobs.push(function (y) {
      // Stop calculating once the hero has left the screen.
      if (hero && y > hero.offsetHeight + 200) return;

      items.forEach(function (el) {
        var depth = parseFloat(el.getAttribute('data-depth')) || 0.1;
        el.style.transform = 'translate3d(0,' + (y * depth).toFixed(2) + 'px,0)';
      });
    });
  }

  /* ------------------------------------------------------------------
     Drifting sand
     ------------------------------------------------------------------ */

  function initSand() {
    var canvases = $$('[data-sand]');
    if (!canvases.length || reduced.matches) return;

    canvases.forEach(function (canvas) {
      var ctx = canvas.getContext('2d');
      if (!ctx) return;

      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var grains = [];
      var w = 0;
      var h = 0;
      var running = true;
      var raf;

      function size() {
        var rect = canvas.getBoundingClientRect();
        w = rect.width;
        h = rect.height;
        canvas.width = Math.floor(w * dpr);
        canvas.height = Math.floor(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        seed();
      }

      function seed() {
        // Fewer grains on a phone: this runs alongside everything else.
        var count = w < 750 ? 34 : 70;
        grains = [];
        for (var i = 0; i < count; i++) {
          grains.push({
            x: Math.random() * w,
            y: h * (0.35 + Math.random() * 0.65),
            r: Math.random() * 1.5 + 0.35,
            vx: 0.16 + Math.random() * 0.55,
            amp: 2 + Math.random() * 9,
            phase: Math.random() * Math.PI * 2,
            speed: 0.006 + Math.random() * 0.016,
            a: 0.1 + Math.random() * 0.4
          });
        }
      }

      var sand = getComputedStyle(document.documentElement)
        .getPropertyValue('--color-sand')
        .trim() || '203 180 138';

      function frame() {
        if (!running) return;
        ctx.clearRect(0, 0, w, h);

        for (var i = 0; i < grains.length; i++) {
          var g = grains[i];
          g.x += g.vx;
          g.phase += g.speed;

          if (g.x - g.r > w) {
            g.x = -g.r;
            g.y = h * (0.35 + Math.random() * 0.65);
          }

          var y = g.y + Math.sin(g.phase) * g.amp;
          ctx.beginPath();
          ctx.arc(g.x, y, g.r, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(' + sand.split(/\s+/).join(',') + ',' + g.a + ')';
          ctx.fill();
        }

        raf = requestAnimationFrame(frame);
      }

      size();
      window.addEventListener('resize', size, { passive: true });

      // Only burn frames while the canvas is actually on screen.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !running) {
              running = true;
              frame();
            } else if (!entry.isIntersecting) {
              running = false;
              cancelAnimationFrame(raf);
            }
          });
        }).observe(canvas);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          running = false;
          cancelAnimationFrame(raf);
        } else if (!running) {
          running = true;
          frame();
        }
      });

      frame();
    });
  }

  /* ------------------------------------------------------------------
     Headline masks
     ------------------------------------------------------------------ */

  function initLines() {
    var lines = $$('.line-mask');
    if (!lines.length) return;

    if (!('IntersectionObserver' in window) || reduced.matches) {
      lines.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    lines.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------------------
     Counting numbers
     ------------------------------------------------------------------ */

  function initCounters() {
    var nums = $$('[data-count]');
    if (!nums.length) return;

    function paint(el, value) {
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      el.textContent = prefix + value.toLocaleString() + suffix;
    }

    // The Liquid renders "<prefix>0<suffix>"; split it back apart once.
    nums.forEach(function (el) {
      var raw = el.textContent.trim();
      var zero = raw.indexOf('0');
      el.setAttribute('data-prefix', zero > -1 ? raw.slice(0, zero) : '');
      el.setAttribute('data-suffix', zero > -1 ? raw.slice(zero + 1) : '');
    });

    if (!('IntersectionObserver' in window) || reduced.matches) {
      nums.forEach(function (el) {
        paint(el, parseInt(el.getAttribute('data-count'), 10) || 0);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          observer.unobserve(el);

          var target = parseInt(el.getAttribute('data-count'), 10) || 0;
          var duration = 1500;
          var start = null;

          function step(now) {
            if (start === null) start = now;
            var t = Math.min((now - start) / duration, 1);
            var eased = 1 - Math.pow(1 - t, 3);
            paint(el, Math.round(target * eased));
            if (t < 1) requestAnimationFrame(step);
          }

          requestAnimationFrame(step);
        });
      },
      { threshold: 0.4 }
    );

    nums.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------------------
     Pinned desert story
     ------------------------------------------------------------------ */

  function initStory() {
    var story = $('[data-story]');
    if (!story) return;

    var steps = $$('[data-story-step]', story);
    var num = $('[data-story-num]', story);
    var ridges = $$('[data-ridge]', story);
    if (!steps.length) return;

    function activate(index) {
      steps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === index);
      });

      if (num) {
        num.style.opacity = '0';
        setTimeout(function () {
          num.textContent = ('0' + (index + 1)).slice(-2);
          num.style.opacity = '0.9';
        }, 160);
      }

      if (!reduced.matches) {
        ridges.forEach(function (path, i) {
          var shift = (index + 1) * (4 + i * 3);
          path.style.transform = 'translateY(' + -shift + 'px)';
        });
      }
    }

    if (!('IntersectionObserver' in window)) {
      activate(0);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = steps.indexOf(entry.target);
          if (index > -1) activate(index);
        });
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
    );

    steps.forEach(function (step) { observer.observe(step); });
  }

  /* ------------------------------------------------------------------
     Mobile bottom bar — slides away as you read down the page
     ------------------------------------------------------------------ */

  function initMobileBar() {
    var bar = document.getElementById('MobileBar');
    if (!bar) return;

    var last = 0;

    scrollJobs.push(function (y) {
      if (document.body.classList.contains('drawer-open')) {
        bar.classList.add('is-hidden');
        return;
      }

      var goingDown = y > last && y > 240;
      bar.classList.toggle('is-hidden', goingDown);
      last = y;
    });
  }

  /* ------------------------------------------------------------------
     Carousel progress hint
     ------------------------------------------------------------------ */

  function initScrollerHints() {
    $$('.scroller').forEach(function (scroller) {
      if (scroller.dataset.hinted === 'true') return;
      scroller.dataset.hinted = 'true';

      var hint = document.createElement('div');
      hint.className = 'scroller-hint';
      hint.innerHTML =
        '<span>Swipe</span><span class="scroller-hint__rail">' +
        '<span class="scroller-hint__bar"></span></span>';

      scroller.insertAdjacentElement('afterend', hint);
      var bar = hint.querySelector('.scroller-hint__bar');

      function update() {
        var max = scroller.scrollWidth - scroller.clientWidth;
        if (max <= 4) {
          hint.style.display = 'none';
          return;
        }
        hint.style.display = '';
        var pct = scroller.scrollLeft / max;
        bar.style.transform = 'translateX(' + pct * 233 + '%)';
      }

      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* ------------------------------------------------------------------
     Staggered mobile menu
     ------------------------------------------------------------------ */

  function initMenuStagger() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-drawer-open="MobileMenu"]');
      if (!opener) return;

      var menu = document.getElementById('MobileMenu');
      if (!menu) return;

      $$('.mobile-nav__link', menu).forEach(function (link, i) {
        link.style.setProperty('--d', 60 + i * 55 + 'ms');
      });
    });
  }


  /* ------------------------------------------------------------------
     Shop-by-type tabs
     ------------------------------------------------------------------ */

  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      if (root.dataset.tabsReady === 'true') return;
      root.dataset.tabsReady = 'true';

      var tabs = $$('[data-tab]', root);
      var panels = $$('[data-panel]', root);
      if (!tabs.length) return;

      function select(key) {
        tabs.forEach(function (tab) {
          tab.setAttribute('aria-selected', tab.getAttribute('data-tab') === key ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-panel') !== key;
        });

        // Re-run the entrance animation on the cards that just appeared.
        var active = panels.filter(function (p) { return !p.hidden; })[0];
        if (active) {
          $$('.reveal', active).forEach(function (el) { el.classList.add('is-in'); });
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          select(tab.getAttribute('data-tab'));
          // Keep the chosen tab in view on a phone.
          tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });

        tab.addEventListener('keydown', function (event) {
          var i = tabs.indexOf(tab);
          var next = null;
          if (event.key === 'ArrowRight') next = tabs[i + 1] || tabs[0];
          if (event.key === 'ArrowLeft') next = tabs[i - 1] || tabs[tabs.length - 1];
          if (!next) return;
          event.preventDefault();
          next.focus();
          select(next.getAttribute('data-tab'));
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------ */


  /* ----------------------------------------------------------------------
     Brand rails — fetch each brand's products as its row nears the viewport.
     Rendering thirty rows server-side would mean six hundred product cards
     on first paint, which no phone connection should have to carry.
     -------------------------------------------------------------------- */
  function initBrandRails() {
    var rails = document.querySelectorAll('[data-brand-rail]:not([data-loaded])');
    if (!rails.length) return;

    function load(rail) {
      if (rail.hasAttribute('data-loaded')) return;
      rail.setAttribute('data-loaded', '');

      var src = rail.getAttribute('data-src');
      if (!src) return;

      fetch(src)
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-brand-track]');
          var slot = rail.querySelector('[data-brand-track]');
          if (!slot) return;

          // No products for this vendor — drop the row rather than leave a gap.
          if (!fresh || !fresh.children.length) {
            rail.classList.add('is-empty');
            return;
          }

          slot.replaceWith(fresh);
          fresh.querySelectorAll('.reveal').forEach(function (el) {
            el.classList.add('is-in');
          });
        })
        .catch(function () {
          // A failed row is hidden; the rest of the page is unaffected.
          rail.classList.add('is-empty');
        });
    }

    if (!('IntersectionObserver' in window)) {
      rails.forEach(load);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          load(entry.target);
        });
      },
      { rootMargin: '800px 0px' }
    );

    rails.forEach(function (rail) {
      io.observe(rail);
    });
  }

  function boot() {
    document.documentElement.classList.add('is-loaded');
    initProgress();
    initParallax();
    initSand();
    initLines();
    initCounters();
    initStory();
    initMobileBar();
    initScrollerHints();
    initMenuStagger();
    initTabs();
    initBrandRails();
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Keep the theme editor previewing correctly when a section is re-rendered.
  document.addEventListener('shopify:section:load', function () {
    initLines();
    initCounters();
    initStory();
    initScrollerHints();
    initSand();
    initTabs();
    initBrandRails();
  });
})();
